import React, { createContext, useState } from 'react';

import dayjs from 'dayjs';

type SearchParams = {
  datePeriod: {
    start: Date;
    end: Date;
  };
  inspectorId: string;
  unloadingDockId: string;
  deliveryRouteId: string;
  isSearched: boolean;
};
type SearchParamsContext = {
  searchParams: SearchParams;
  setSearchParams: React.Dispatch<React.SetStateAction<SearchParams>>;
};

const now = new Date(); // Ex: now === 2022-03-30 12:34:56
// 1 month
const defaultSearchParamsValue: SearchParams = {
  datePeriod: {
    start: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29), // 2022-03-01 0:00:00
    end: dayjs(now).endOf('day').toDate(), // 2022-03-30 23:59:59
  },
  inspectorId: '',
  unloadingDockId: '',
  deliveryRouteId: '',
  isSearched: false,
};

/**
 * /viewにて検収のinputとして使用するパラメータを管理する
 */
export const SearchParamsContext: React.Context<SearchParamsContext> =
  createContext({
    searchParams: defaultSearchParamsValue,
    setSearchParams: (_) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars
  });

export const SearchParamsContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [searchParams, setSearchParams] = useState(defaultSearchParamsValue);

  return (
    <SearchParamsContext.Provider
      value={{
        searchParams,
        setSearchParams,
      }}
    >
      {children}
    </SearchParamsContext.Provider>
  );
};
